import {Injectable} from '@angular/core';
import {productValuesType} from '../interfaces';
import {CurrentSystemService} from './currentSystem.service';

@Injectable()
export class CalculateAaeroAgeoService {
	currentSystem = '';
	pv: productValuesType;

	constructor(private currentSystemService: CurrentSystemService) { }

	/**
	 * set current system
	 */
	setCurrentSystem() {
		this.currentSystem = this.currentSystemService.getCurrentSystem();
		this.pv = this.currentSystemService.getCurrentPvs();
	}

	/**
	 * calculate aero
	 * @param width
	 * @param height
	 */
	calcAaero(width: number, height: number){
		console.log('CV: ',this.calculateCv(width, height));
		return ((width / 1000 - this.pv.dimensionsOpenLouvre.sideMullion / 1000 - this.pv.dimensionsOpenLouvre.sideMullion / 1000 ) *
		(height / 1000 - this.pv.dimensionsOpenLouvre.profileTop / 1000 - this.pv.dimensionsOpenLouvre.profileBottom / 1000)) * this.calculateCv(width, height);
	};

	/**
	 * change louvre array and min and max
	 * @param height
	 * @param middleMullion
	 * @returns louvres: any[]; min: number; max: number
	 */
	changeLouvresValues(height: number, middleMullion: boolean){
		console.log('louvres, mp', middleMullion);
		let louvres = [];

		let min = this.calculateMinLouvres(height);
		let max = this.calculateMaxLouvres(height);

		if (middleMullion) {
			min *= 2;
			max *= 2;
		}

		let length = max - min + 1;


		for (let i = 0; i < length;i++) {
			if (middleMullion){
				if (i % 2 == 0) {
					louvres.push(i + min);
				}
			} else {
				louvres.push(i + min);
			}

		}

		return {
			louvres: louvres,
			min: min,
			max: max
		}
	}

	/**
	 * calculate louvre height
	 * @param height
	 * @param louvresCount
	 * @param middleMullion
	 */
	calculateLouvreHeight(height: number, louvresCount: number, middleMullion: number){

		const mm = middleMullion ? 1 : 0;
		const nrLouvres = mm ? louvresCount / 2 : louvresCount;

		if (this.currentSystem === 'FLM') {
			return Math.round((height - 33) / nrLouvres + 11)
		}
		if (this.currentSystem === 'FLW28' || this.currentSystem === 'FLW24') {
			return Math.round((height - 45) / nrLouvres - 5)
		}
		return Math.round((height - 85) / nrLouvres - 5)

	}

	/**
	 * calculate ageo
	 * @param height
	 * @param width
	 * @param louvreCount
	 * @param middleMullion
	 * @param glass
	 */
	calculateAgeo(width: number, height: number, louvreCount: number, middleMullion: number, glass: number) {
		// console.log('ageo', middleMullion);
		// console.log('GLASS', glass);
		const  mm = middleMullion ? 1 : 0;
		louvreCount = middleMullion ? louvreCount / 2 : louvreCount;

		if (this.currentSystem === 'FLW28' || this.currentSystem === 'FLW24') {
			return (width / 1000 - 2 * (this.pv.dimensionsOpenLouvre.sideMullion  / 1000 ) - mm * (this.pv.dimensionsOpenLouvre.mm / 1000 )) *
			(height / 1000 - this.pv.dimensionsOpenLouvre.profileTop / 1000 - this.pv.dimensionsOpenLouvre.profileBottom / 1000 - ( louvreCount * (this.pv.dimensionsOpenLouvre.louvre / 1000 )));
		}

		if (this.currentSystem === 'FLM') {
			return ((width / 1000 - 2 * (this.pv.dimensionsOpenLouvre.sideMullion  / 1000 ) - mm * (this.pv.dimensionsOpenLouvre.mm / 1000 )) *
				(height / 1000 - this.pv.dimensionsOpenLouvre.profileTop / 1000 - this.pv.dimensionsOpenLouvre.profileBottom / 1000 - (louvreCount * glass / 1000)));
		}
		return (width / 1000 - 2 * (this.pv.dimensionsOpenLouvre.sideMullion / 1000)) *
			(height / 1000 - this.pv.dimensionsOpenLouvre.profileTop / 1000 - this.pv.dimensionsOpenLouvre.profileBottom / 1000 - ((louvreCount * this.pv.dimensionsOpenLouvre.louvre ) / 1000))
	}

	/**
	 * calculate cv
	 * @param width
	 * @param height
	 */
	private calculateCv(width: number, height: number){

		const maxNumbers = this.currentSystem === 'FLM' ? [1,3] : [2,4];

		if (width/height <= maxNumbers[0]) {
			return this.calculateCv1(width, height)
		}
		if (width/height > maxNumbers[0] && width/height <= maxNumbers[1]) {
			return  this.calculateCv2(width, height)
		}
		return this.calculateCv3();
	}

	private calculateCv1(width: number, height: number){
		const CV1Factor = this.currentSystem === 'FLM' ? 1 : 2;
		const cv = this.pv.cvReference85deg - this.pv.cvFactors.cv1 * ( CV1Factor - width / height);
		console.log('CV1', cv);
		return cv;
	}
	private calculateCv2(width, height){
		const CV2Factor = this.currentSystem === 'FLM' ? 0 : 2;
		const cv = this.pv.cvReference85deg - this.pv.cvFactors.cv2 * ( width / height - CV2Factor);
		console.log('CV2', cv);
		return cv;
	}
	private calculateCv3(){
		const cv = this.pv.cvReference85deg - this.pv.cvFactors.cv3;
		console.log('CV3', cv);
		return cv;
	}

	/**
	 * calculate min louvres
	 * @param height
	 * @returns number
	 */
	private calculateMinLouvres(height: number){
		if (this.currentSystem === 'FLL') {
			return  Math.ceil(( this.pv.windowHeight.min - this.pv.edgeWidth * 2 - this.pv.gabDimensions.top - this.pv.gabDimensions.bottom ) / 131)
		}
		if (this.currentSystem === 'FLM') {
			return  Math.ceil((height - 16.5 * 2 - this.pv.gabDimensions.top - this.pv.gabDimensions.bottom) / this.pv.louvreHeight.max);
		}
		if (this.currentSystem === 'FLW24') {
			return  Math.ceil((height - 20 * 2 - this.pv.gabDimensions.top - this.pv.gabDimensions.bottom) / this.pv.louvreHeight.max);
		}

		return Math.ceil((height - 40 * 2 - this.pv.gabDimensions.top - this.pv.gabDimensions.bottom) / this.pv.louvreHeight.max);
	}

	/**
	 * calculate max louvres
	 * @param height
	 * @returns number
	 */
	private calculateMaxLouvres(height: number) {
		if (this.currentSystem === 'FLL') {
			//=ABRUNDEN((Tabelle1!Q27-Tabelle1!T27*2-Tabelle1!Q45-Tabelle1!S45)/131;0)
			return Math.floor((this.pv.windowHeight.max - this.pv.edgeWidth * 2 - this.pv.gabDimensions.top - this.pv.gabDimensions.bottom ) / this.pv.louvreHeight.max);
		}
		if (this.currentSystem === 'FLM') {
			return Math.floor((height - 16.5 * 2 - this.pv.gabDimensions.top - this.pv.gabDimensions.bottom) / this.pv.louvreHeight.min);
		}
		if (this.currentSystem === 'FLW24') {
			return Math.floor((height - 20 * 2 - this.pv.gabDimensions.top - this.pv.gabDimensions.bottom) / this.pv.louvreHeight.min);
		}
		return Math.floor((height - 40 * 2 - this.pv.gabDimensions.top - this.pv.gabDimensions.bottom) / this.pv.louvreHeight.min);
	}

}